// The operation panel's "Parts on order": every PO line ordered for this operation (a tech's PO from
// the techs app, or one the office placed from Add part), with its vendor, where it stands and when it's
// expected, so the office can answer "when will my boat be done?" without opening Inventory. A tech's PO
// still waiting on the office shows too. Tapping a tech's PO opens it in Inbox › Part requests (where
// the expected delivery is changed); Inventory › Receiving changes it too.
//
// Reads the device copy of /inventoryPOs (deviceCopy.js: no download of the whole section) and this
// operation's /poRequests (a query on Op_Id).

import { ref, query, orderByChild, equalTo, onValue } from 'firebase/database';
import { database } from './initFirebase';
import { deviceCopy } from './deviceCopy';
import { escapeHTML } from './utilities';
import { opOrderRows } from './opOrdersCore';

const esc = v => escapeHTML(v == null ? '' : String(v));
const todayDay = () => new Date().toLocaleDateString('en-CA');
const S = { opId: null, reqs: {}, pos: {}, offReq: null, offPos: null, slot: null };

function paint() {
  const slot = S.slot;
  if (!slot) return;
  const rows = opOrderRows(S.opId, S.pos, S.reqs, todayDay());
  slot.hidden = !rows.length;
  if (!rows.length) { slot.innerHTML = ''; return; }
  slot.innerHTML = `<div class="op-orders-head">Parts on order</div>
    ${rows.map(r => `<${r.fromTech ? 'button type="button"' : 'div'} class="op-order op-order--${r.tone}" data-req="${r.fromTech ? esc(r.id) : ''}">
      <span class="op-order-top"><b class="op-order-ref">${esc(r.ref)}</b> ${esc(r.vendor)}</span>
      <span class="op-order-items">${esc(r.items)}</span>
      <span class="op-order-state">${esc(r.text)}</span>
    </${r.fromTech ? 'button' : 'div'}>`).join('')}`;
  slot.querySelectorAll('button[data-req]').forEach((b) => { b.onclick = () => openRequest(b.dataset.req); });
}

async function openRequest(id) {
  document.getElementById('part-requests-rail-button')?.click();
  // The Part requests page picks it up once it has loaded (partRequests.js listens for this).
  const send = () => document.querySelector('#partRequests iframe')?.contentWindow?.postMessage({ to: 'partRequests', select: id }, location.origin);
  [400, 1500, 3500].forEach(ms => setTimeout(send, ms));
}

/** Draw (and keep current) the section for this operation, just above the checklist. */
export function renderOpOrders(anchor, op) {
  if (!anchor || !op?.Job_ID) return;
  let slot = document.getElementById('opOrdersSlot');
  if (!slot) {
    slot = document.createElement('div');
    slot.id = 'opOrdersSlot';
    slot.className = 'op-orders';
    slot.hidden = true;
    anchor.before(slot);
  }
  S.slot = slot;
  if (S.opId === op.Job_ID) { paint(); return; }
  S.opId = op.Job_ID;
  S.reqs = {};
  S.offReq?.();
  const opId = op.Job_ID;
  S.offReq = onValue(query(ref(database, 'poRequests'), orderByChild('Op_Id'), equalTo(opId)), (s) => { if (S.opId === opId) { S.reqs = s.val() || {}; paint(); } }, () => { S.reqs = {}; });
  const copy = deviceCopy('inventoryPOs');
  copy.all().then((all) => { S.pos = all || {}; paint(); }).catch(() => {});
  if (!S.offPos) S.offPos = copy.onChange(() => copy.all().then((all) => { S.pos = all || {}; paint(); }).catch(() => {}));
  paint();
}
